export default [
  { key: `male`, value: `male`, text: `Male` },
  { key: `female`, value: `female`, text: `Female` },
];
